import React from 'react';
import { useWatchlist } from '../useContext/WatchlistContext';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';

const WatchlistDemo = () => {
  const { 
    watchlist, 
    favorites, 
    addToWatchlist, 
    addToFavorites, 
    removeFromWatchlist, 
    removeFromFavorites,
    getWatchlistCount, 
    getFavoritesCount,
    loading 
  } = useWatchlist();

  // Sample movies for testing
  const sampleMovies = [
    {
      id: 550,
      title: 'Fight Club',
      type: 'movie',
      poster_path: '/pB8BM7pdSp6B6Ih7QZ4DrQ3PmJK.jpg',
      imgSrc: 'https://image.tmdb.org/t/p/w500/pB8BM7pdSp6B6Ih7QZ4DrQ3PmJK.jpg',
      vote_average: 8.4,
      release_date: '1999-10-15',
      overview: 'A ticking-time-bomb insomniac and a slippery soap salesman channel primal male aggression into a shocking new form of therapy.',
      adult: false
    },
    {
      id: 13,
      title: 'Forrest Gump',
      type: 'movie',
      poster_path: '/arw2vcBveWOVZr6pxd9XTd1TdQa.jpg',
      imgSrc: 'https://image.tmdb.org/t/p/w500/arw2vcBveWOVZr6pxd9XTd1TdQa.jpg',
      vote_average: 8.5,
      release_date: '1994-06-23',
      overview: 'A man with a low IQ has accomplished great things in his life and been present during significant historic events.',
      adult: false
    },
    {
      id: 155,
      title: 'The Dark Knight',
      type: 'movie',
      poster_path: '/qJ2tW6WMUDux911r6m7haRef0WH.jpg',
      imgSrc: 'https://image.tmdb.org/t/p/w500/qJ2tW6WMUDux911r6m7haRef0WH.jpg',
      vote_average: 8.5,
      release_date: '2008-07-16',
      overview: 'Batman raises the stakes in his war on crime with the help of Lt. Jim Gordon and District Attorney Harvey Dent.',
      adult: false
    }
  ];

  const sampleTVShows = [
    {
      id: 1399,
      title: 'Game of Thrones',
      type: 'tv',
      poster_path: '/u3bZgnGQ9T01sWNhyveQz0wH0Hl.jpg',
      imgSrc: 'https://image.tmdb.org/t/p/w500/u3bZgnGQ9T01sWNhyveQz0wH0Hl.jpg',
      vote_average: 8.3,
      release_date: '2011-04-17',
      overview: 'Seven noble families fight for control of the mythical land of Westeros.',
      adult: false
    },
    {
      id: 82856,
      title: 'The Mandalorian',
      type: 'tv',
      poster_path: '/eU1i6eHXlzMOlEq0ku1Rzq7Y4wA.jpg',
      imgSrc: 'https://image.tmdb.org/t/p/w500/eU1i6eHXlzMOlEq0ku1Rzq7Y4wA.jpg',
      vote_average: 8.5,
      release_date: '2019-11-12',
      overview: 'The travels of a lone bounty hunter in the outer reaches of the galaxy.',
      adult: false
    }
  ];

  const handleAddToWatchlist = (item) => {
    addToWatchlist(item);
  };

  const handleAddToFavorites = (item) => {
    addToFavorites(item);
  };

  const handleRemoveFromWatchlist = (item) => {
    removeFromWatchlist(item.id, item.type);
  };

  const handleRemoveFromFavorites = (item) => {
    removeFromFavorites(item.id, item.type);
  };

  return (
    <Container className="mt-5">
      <Row>
        <Col md="12">
          <h2 className="text-white mb-4">Watchlist & Favorites Demo</h2>
          
          {/* Stats */}
          <Row className="mb-4">
            <Col md="6">
              <Card className="bg-dark text-white">
                <Card.Body>
                  <h5>Current Stats</h5>
                  <p>Watchlist Count: {getWatchlistCount()}</p>
                  <p>Favorites Count: {getFavoritesCount()}</p>
                  <p>Loading: {loading ? 'Yes' : 'No'}</p>
                  <Link to="/watchlist" className="btn btn-primary me-2">
                    View Watchlist
                  </Link>
                  <Link to="/watchlist?tab=favourite" className="btn btn-danger">
                    View Favorites
                  </Link>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Sample Movies */}
          <Row className="mb-4">
            <Col md="12">
              <h4 className="text-white">Sample Movies</h4>
              <Row>
                {sampleMovies.map((movie) => (
                  <Col md="4" key={movie.id} className="mb-3">
                    <Card className="bg-dark text-white">
                      <Card.Img 
                        variant="top" 
                        src={movie.imgSrc} 
                        style={{ height: '300px', objectFit: 'cover' }}
                      />
                      <Card.Body>
                        <Card.Title>{movie.title}</Card.Title>
                        <Card.Text className="small">{movie.overview.substring(0, 100)}...</Card.Text>
                        <div className="d-flex gap-2">
                          <Button 
                            variant="warning" 
                            size="sm"
                            onClick={() => handleAddToWatchlist(movie)}
                            disabled={loading}
                          >
                            Add to Watchlist
                          </Button>
                          <Button 
                            variant="danger" 
                            size="sm"
                            onClick={() => handleAddToFavorites(movie)}
                            disabled={loading}
                          >
                            Add to Favorites
                          </Button>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>

          {/* Sample TV Shows */}
          <Row className="mb-4">
            <Col md="12">
              <h4 className="text-white">Sample TV Shows</h4>
              <Row>
                {sampleTVShows.map((show) => (
                  <Col md="4" key={show.id} className="mb-3">
                    <Card className="bg-dark text-white">
                      <Card.Img 
                        variant="top" 
                        src={show.imgSrc} 
                        style={{ height: '300px', objectFit: 'cover' }}
                      />
                      <Card.Body>
                        <Card.Title>{show.title}</Card.Title>
                        <Card.Text className="small">{show.overview.substring(0, 100)}...</Card.Text>
                        <div className="d-flex gap-2">
                          <Button 
                            variant="warning" 
                            size="sm"
                            onClick={() => handleAddToWatchlist(show)}
                            disabled={loading}
                          >
                            Add to Watchlist
                          </Button>
                          <Button 
                            variant="danger" 
                            size="sm"
                            onClick={() => handleAddToFavorites(show)}
                            disabled={loading}
                          >
                            Add to Favorites
                          </Button>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>

          {/* Current Watchlist */}
          {watchlist.length > 0 && (
            <Row className="mb-4">
              <Col md="12">
                <h4 className="text-white">Current Watchlist ({watchlist.length})</h4>
                <Row>
                  {watchlist.map((item) => (
                    <Col md="3" key={`${item.type}-${item.id}`} className="mb-3">
                      <Card className="bg-dark text-white">
                        <Card.Img 
                          variant="top" 
                          src={item.imgSrc || `https://image.tmdb.org/t/p/w500${item.poster_path}`} 
                          style={{ height: '200px', objectFit: 'cover' }}
                        />
                        <Card.Body>
                          <Card.Title className="small">{item.title}</Card.Title>
                          <Button 
                            variant="outline-danger" 
                            size="sm"
                            onClick={() => handleRemoveFromWatchlist(item)}
                            disabled={loading}
                          >
                            Remove
                          </Button>
                        </Card.Body>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </Col>
            </Row>
          )}

          {/* Current Favorites */}
          {favorites.length > 0 && (
            <Row className="mb-4">
              <Col md="12">
                <h4 className="text-white">Current Favorites ({favorites.length})</h4>
                <Row>
                  {favorites.map((item) => (
                    <Col md="3" key={`${item.type}-${item.id}`} className="mb-3">
                      <Card className="bg-dark text-white">
                        <Card.Img 
                          variant="top" 
                          src={item.imgSrc || `https://image.tmdb.org/t/p/w500${item.poster_path}`} 
                          style={{ height: '200px', objectFit: 'cover' }}
                        />
                        <Card.Body>
                          <Card.Title className="small">{item.title}</Card.Title>
                          <Button 
                            variant="outline-danger" 
                            size="sm"
                            onClick={() => handleRemoveFromFavorites(item)}
                            disabled={loading}
                          >
                            Remove
                          </Button>
                        </Card.Body>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </Col>
            </Row>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default WatchlistDemo;
